import styled from '@emotion/styled';
import { Badge } from '@tablecheck/tablekit-react';

import { Incident } from 'components/statusPage/types';

export const AlertWrapper = styled.div<{
  'data-variant': Incident['displayStatus'];
}>`
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: var(--border-radius-large);
  --alert-background: var(--surface);
  --alert-icon: var(--neutral-text);
  background-color: var(--alert-background);

  svg {
    color: var(--alert-icon);
  }

  &[data-variant='maintenance'] {
    --alert-background: #a7cce9;
    --alert-icon: #006abd;
  }

  &[data-variant='critical'] {
    --alert-background: #d9a1a3;
    --alert-icon: #c80007;
  }

  &[data-variant='major'] {
    --alert-background: #f2cc9a;
    --alert-icon: #bd6b00;
  }

  &[data-variant='minor'] {
    --alert-background: #f9f8be;
    --alert-icon: #dfb13d;
  }

  &[data-variant='resolved'] {
    --alert-background: #a1e895;
    --alert-icon: #17a800;
  }

  &:hover {
    cursor: pointer;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-l3);
  justify-content: space-between;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
  padding: var(--spacing-l3);
  font: var(--label);
  min-height: 48px;
`;

export const LabelWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: var(--spacing-l3);
  overflow: hidden;

  svg {
    align-self: flex-start;
    flex-shrink: 0;
  }
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: var(--spacing-l2);
  padding: var(--spacing-l3);
  font: var(--body-2);
`;

export const StyledBadge = styled(Badge)`
  align-self: flex-start;
  flex-shrink: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
`;
